import React from "react";
import SchoolAdmissionPayment from "../pages/schoolCockpit/admission/SchoolAdmissionPayment";
import AdmissionCycleConfigList from "../pages/schoolCockpit/admission/admissionCycleConfig/AdmissionCycleConfigList";
import AdmissionCycleConfigView from "../pages/schoolCockpit/admission/admissionCycleConfig/AdmissionCycleConfigView";
import AdmissionCycleConfigCreate from "../pages/schoolCockpit/admission/admissionCycleConfig/AdmissionCycleConfigCreate";
import AdmissionSeatAllocationConfigView from "../pages/schoolCockpit/admission/admissionSeatAllocationConfig/AdmissionSeatAllocationConfigView";
import AdmissionSeatAllocationConfigList from "../pages/schoolCockpit/admission/admissionSeatAllocationConfig/AdmissionSeatAllocationConfigList";
import AdmissionSeatAllocationConfigCreate from "../pages/schoolCockpit/admission/admissionSeatAllocationConfig/AdmissionSeatAllocationConfigCreate";
import AdmissionListTabs from "../pages/schoolCockpit/admission/admissionList/AdmissionListTabs";
import AdmissionCaptureIntList from "../pages/schoolCockpit/admission/AdmissionCaptureIntList";
import StudentReport from "../pages/schoolCockpit/report/StudentReport";
import StudentAttendanceReport from "../pages/schoolCockpit/report/StudentAttendanceReport";
import CreatetimetbListView from "../pages/schoolCockpit/timeTable/CreatetimetbListView";
import StudentShift from "../pages/schoolCockpit/timeTable/shift/ShiftList";
import StudentTimeList from "../pages/schoolCockpit/timeTable/studenttimetable/StudentTimeList";
import StaffList from "../pages/schoolCockpit/master/StaffList";
import AcademicList from "../pages/schoolCockpit/master/academicConfiguration/AcademicList";
import StudentList from "../pages/schoolCockpit/master/student/StudentList";
import HolidayList from "../pages/schoolCockpit/master/holiday/HolidayList";
import HolidayCreate from "../pages/schoolCockpit/master/holiday/HolidayCreate";
import Receiver from "../pages/schoolCockpit/master/Receiver";
import Iotlist from "../pages/schoolCockpit/master/Iotlist";
import CalendarList from "../pages/schoolCockpit/events/CalendarList";
import CalendarInfoCreate from "../pages/schoolCockpit/events/CalendarInfoCreate";
import ExamRulesList from "../pages/schoolCockpit/exam/examRules/ExamRulesList";
import ExamRulesCreate from "../pages/schoolCockpit/exam/examRules/ExamRulesCreate";
import ExamScheduleList from "../pages/schoolCockpit/exam/examSchedule/ExamScheduleList";
import ExamScheduleView from "../pages/schoolCockpit/exam/examSchedule/ExamScheduleView";
import ExamScheduleCreate from "../pages/schoolCockpit/exam/examSchedule/ExamScheduleCreate";
import ExamConfigurationList from "../pages/schoolCockpit/exam/examConfiguration/ExamConfigurationList";
import ExamConfigurationCreate from "../pages/schoolCockpit/exam/examConfiguration/ExamConfigurationCreate";
import GroupCockpitProfile from "../pages/groupCockpit/GroupCockpitProfile";
import ChangePassword from "../pages/groupCockpit/ChangePassword";
import UserDashboardResolver from "./UserDashboardResolver";
import ContentManagement from "../pages/schoolCockpit/contentManagement/ContentManagement";
import CreateMessage from "../pages/groupCockpit/message/Createmessage";
import MessagingEmail from "../pages/groupCockpit/message/MessagingEmail";
import HallofFameInfoCreate from "../pages/schoolCockpit/contentManagement/HallOfFame/HallofFameInfoCreate";
import ViewHallOfFame from "../pages/schoolCockpit/contentManagement/HallOfFame/ViewHallOfFame";
import ManagementTalkInfoCreate from "../pages/schoolCockpit/contentManagement/ManagementTalk/ManagementTalkInfoCreate";
import NewsandBlogInfoCreate from "../pages/schoolCockpit/contentManagement/NewaAndBlogs/NewsandBlogInfoCreate";
import AnnouncementInfoCreate from "../pages/schoolCockpit/contentManagement/Announcement/AnnouncementInfoCreate";
import OpinionInfoCreate from "../pages/schoolCockpit/contentManagement/OpinionPoll/OpinionInfoCreate";
import AcademicCreate from "../pages/schoolCockpit/master/academicConfiguration/AcademicCreate";
import StaffSetUp from "../pages/schoolCockpit/master/StaffSetUp";
import ClassList from "../pages/schoolCockpit/master/class/ClassList";
import ClassSectionList from "../pages/schoolCockpit/master/class/ClassSectionList";
import ClassCreate from "../pages/schoolCockpit/master/class/ClassCreate";
import ViewOpinionPoll from "../pages/schoolCockpit/contentManagement/OpinionPoll/ViewOpinionPoll";
import ViewAnnouncement from "../pages/schoolCockpit/contentManagement/Announcement/ViewAnnouncement";
import ViewNewsAndBlogs from "../pages/schoolCockpit/contentManagement/NewaAndBlogs/ViewNewsAndBlogs";
import ViewManagementTalk from "../pages/schoolCockpit/contentManagement/ManagementTalk/ViewManagementTalk";
import ReadMoreAnnouncement from "../pages/schoolCockpit/ReadMoreAnnouncement";
import ShiftCreate from "../pages/schoolCockpit/timeTable/shift/ShiftCreate";
import CreateSubject from "../pages/schoolCockpit/master/subject/CreateSubject";
import ListSubject from "../pages/schoolCockpit/master/subject/ListSubject";
import StudentCreate from "../pages/schoolCockpit/master/student/StudentCreate";
import BulkUpload from "../pages/schoolCockpit/master/bulkUpload/BulkUpload";
import GroupCreate from "../pages/schoolCockpit/master/group/GroupCreate";
import GroupList from "../pages/schoolCockpit/master/group/GroupList";
import CreateTimeTable from "../pages/schoolCockpit/timeTable/studenttimetable/CreateTimeTable";
import SyllabusCreate from "../pages/schoolCockpit/master/syllabus/SyllabusCreate";
import SchoolClassList from "../pages/schoolCockpit/master/syllabus/SchoolClassList";
import SyllabusList from "../pages/schoolCockpit/master/syllabus/SyllabusList";
import SyllabusView from "../pages/schoolCockpit/master/syllabus/SyllabusView";
import ViewTimeTable from "../pages/schoolCockpit/timeTable/ViewTimeTable";
import CreateTimeTableList from "../pages/schoolCockpit/timeTable/CreateTimeTableList";
import ExamResult from "../pages/schoolCockpit/exam/examResult/ExamResult";
import StudentAttendanceDashboard from "../pages/schoolCockpit/studentstaffdashboard/studentattendence";
import StudentAttendanceListView from "../pages/schoolCockpit/studentstaffdashboard/studentattendencelistview";
import StaffAttendanceDashboard from "../pages/schoolCockpit/studentstaffdashboard/staffattendence";
import StaffAttendanceListView from "../pages/schoolCockpit/studentstaffdashboard/staffattendencelistview";
import ViewAllAnnouncement from "../pages/schoolCockpit/contentManagement/Announcement/ViewAllAnnouncement";
import AdmissionScheduleList from "../pages/schoolCockpit/admission/AdmissionSchedule/AdmissionScheduleList";
import AdmissionScheduleCreate from "../pages/schoolCockpit/admission/AdmissionSchedule/AdmissionScheduleCreate";
import ViewAdmissionSchedule from "../pages/schoolCockpit/admission/AdmissionSchedule/ViewAdmissionSchedule";
import ViewAdmissionCaptureIntList from "../pages/schoolCockpit/admission/ViewAdmissionCaptureIntList";
import OfflineApplicationUpload from "../pages/schoolCockpit/admission/OfflineApplication/OfflineApplicationUpload";
import BookList from "../pages/schoolCockpit/book/BookList";
import BookCreate from "../pages/schoolCockpit/book/BookCreate";
import BookView from "../pages/schoolCockpit/book/BookView";
import BookEdit from "../pages/schoolCockpit/book/BookEdit";
import LessonPlanApprovalList from "../pages/schoolCockpit/aiAssistant/LessonPlanApproval/AiLessonPlanApprovalList";
import ViewLessonPlanApproval from "../pages/schoolCockpit/aiAssistant/LessonPlanApproval/AllApproval/ViewAllLessPlanApproval/ViewLessonPlanApproval";
import ViewClasswiseApproval from "../pages/schoolCockpit/aiAssistant/LessonPlanApproval/ClassWiseApproval/ViewClasswiseApproval";
import ViewTeacherWiseApproval from "../pages/schoolCockpit/aiAssistant/LessonPlanApproval/TeacherwiseApproval/ViewTeacherWiseApproval";
import AiDashboard from "../pages/schoolCockpit/aidashboard/AiDashboard";
import ListFeeDiscount from "../pages/schoolCockpit/feesManagement/FeeDiscount/ListFeeDiscount";
import CreateFeeDiscount from "../pages/schoolCockpit/feesManagement/FeeDiscount/CreateFeeDiscount";
import ListFeeType from "../pages/schoolCockpit/feesManagement/FeeType/ListFeeType";
import CreateFeeType from "../pages/schoolCockpit/feesManagement/FeeType/CreateFeeType";
import ListFeeAssign from "../pages/schoolCockpit/feesManagement/FeesAssign/ListFeeAssign";
import CreateFeeAssign from "../pages/schoolCockpit/feesManagement/FeesAssign/CreateFeeAssign";
import ViewFeeAssign from "../pages/schoolCockpit/feesManagement/FeesAssign/ViewFeeAssign";
import GroupFeeList from "../pages/schoolCockpit/feesManagement/GroupFee/GroupFeeList";
import GroupFeeCreate from "../pages/schoolCockpit/feesManagement/GroupFee/GroupFeeCreate";
import ListCollectFees from "../pages/schoolCockpit/feesManagement/CollectFees/ListCollectFees";
import ListPaymentApproval from "../pages/schoolCockpit/feesManagement/PaymentApproval/ListPaymentApproval";
import PayFees from "../pages/parent/feesManagement/PayFees";
import ListAdmissionCollectFees from "../pages/schoolCockpit/admission/admissionList/collectFees/CollectFees";
import ViewCollectFees from "../pages/schoolCockpit/admission/admissionList/collectFees/ViewCollectFees";
import FeeDashboard from "../pages/schoolCockpit/feesManagement/feeDashboard/FeeDashboard";
import DueFeeReport from "../pages/schoolCockpit/feesManagement/feeReport/DueFeeReport";
import DiscountReport from "../pages/schoolCockpit/feesManagement/feeReport/DiscountReport";
import FeesTransactionsReportTabs from "../pages/schoolCockpit/feesManagement/feeReport/FeesTransactionsReportTabs";
import Settings from "../pages/schoolCockpit/settings/Settings";
import SchoolSetUp from "../pages/groupCockpit/schoolSetUp/Schoolsetup";

// Export routes as configuration array
export const schoolCockpitRoutes = [
  // Dashboard
  { path: "dashboard", element: <UserDashboardResolver /> },
  // { path: "dashboard", element: <SchoolCockpitDashboard /> },

  // Admission
  { path: "payment", element: <SchoolAdmissionPayment /> },
  { path: "Admission-Cycle-Config", element: <AdmissionCycleConfigList /> },
  {
    path: "admission-schedule",
    element: <AdmissionScheduleList />,
  },
  {
    path: "view-admission-schedule",
    element: <ViewAdmissionSchedule />,
  },
  {
    path: "AdmissionScheduleCreate",
    element: <AdmissionScheduleCreate />,
  },
  {
    path: "OfflineApplicationUpload",
    element: <OfflineApplicationUpload />,
  },
  {
    path: "Admission-Cycle-Config-View",
    element: <AdmissionCycleConfigView />,
  },
  {
    path: "Admission-Cycle-Config-Create",
    element: <AdmissionCycleConfigCreate />,
  },
  {
    path: "admission-seat-allocation-config",
    element: <AdmissionSeatAllocationConfigList />,
  },
  {
    path: "admission-seat-allocation-config/create",
    element: <AdmissionSeatAllocationConfigCreate />,
  },
  {
    path: "admission-seat-allocation-config/view",
    element: <AdmissionSeatAllocationConfigView />,
  },
  { path: "Admission-List", element: <AdmissionListTabs /> },
  { path: "Academic-Transition", element: <AdmissionCaptureIntList /> },
  {
    path: "View-Academic-Transition",
    element: <ViewAdmissionCaptureIntList />,
  },

  // Report
  { path: "studentReport", element: <StudentReport /> },

  {
    path: "StudentAttendanceReportGenerate",
    element: <StudentAttendanceReport />,
  },

  // Ai Assistabt
  { path: "lessonPlanApproval", element: <LessonPlanApprovalList /> },
  { path: "lessonplanview", element: <ViewLessonPlanApproval /> },
  { path: "classWiseview", element: <ViewClasswiseApproval /> },
  { path: "teacherWiseview", element: <ViewTeacherWiseApproval /> },

  // Time Table
  { path: "timetable", element: <StudentShift /> },
  { path: "shiftcreate", element: <ShiftCreate /> },
  { path: "timeList", element: <StudentTimeList /> },
  { path: "CreateTimeTable", element: <CreateTimeTable /> },
  { path: "createtimetbListView", element: <CreatetimetbListView /> },
  { path: "createtimetbList", element: <CreateTimeTableList /> },

  { path: "viewTimeTable", element: <ViewTimeTable /> },

  // Message
  // Messaging Routes
  {
    path: "messaging/create",
    element: <CreateMessage />,
  },
  { path: "messaging/email", element: <MessagingEmail /> },

  // Events
  { path: "calender/create", element: <CalendarInfoCreate /> },
  { path: "calenderList", element: <CalendarList /> },

  // Master
  { path: "staffList", element: <StaffList /> },
  { path: "staffSetup", element: <StaffSetUp /> },
  { path: "classList", element: <ClassList /> },
  { path: "classSectionList", element: <ClassSectionList /> },
  { path: "classCreate", element: <ClassCreate /> },
  { path: "student", element: <StudentList /> },
  { path: "studentCreate", element: <StudentCreate /> },
  { path: "holidayList", element: <HolidayList /> },
  { path: "holidayCreate", element: <HolidayCreate /> },
  { path: "SchoolClassList", element: <SchoolClassList /> },
  { path: "syllabusList", element: <SyllabusList /> },
  { path: "syllabusView", element: <SyllabusView /> },
  { path: "syllabusCreate", element: <SyllabusCreate /> },
  { path: "bookList", element: <BookList /> },
  { path: "bookCreate", element: <BookCreate /> },
  { path: "bookView", element: <BookView /> },
  { path: "editBook/:id", element: <BookEdit /> },

  { path: "upload", element: <BulkUpload /> },
  { path: "academicList", element: <AcademicList /> },
  { path: "academicCreate", element: <AcademicCreate /> },
  { path: "classList", element: <ClassList /> },
  { path: "CreateSubject", element: <CreateSubject /> },
  { path: "ListSubject", element: <ListSubject /> },
  { path: "receiver", element: <Receiver /> },
  { path: "iotlist", element: <Iotlist /> },
  { path: "GroupCreate", element: <GroupCreate /> },
  { path: "GroupList", element: <GroupList /> },

  // Events
  { path: "examList", element: <ExamConfigurationList /> },
  { path: "examCreate", element: <ExamConfigurationCreate /> },

  { path: "examRulesList", element: <ExamRulesList /> },
  { path: "examRulesCreate", element: <ExamRulesCreate /> },

  { path: "examSchedule", element: <ExamScheduleList /> },
  { path: "examScheduleView", element: <ExamScheduleView /> },
  { path: "examScheduleCreate", element: <ExamScheduleCreate /> },

  { path: "examTimeTable", element: <ExamScheduleView /> },
  // { path: "examTimeTable", element: <ExamTimeTable /> },
  { path: "examResult", element: <ExamResult /> },

  // Attendance Dashboard
  {
    path: "Student-Attendance-Dashboard",
    element: <StudentAttendanceDashboard />,
  },
  {
    path: "Student-Attendance-Dashboard-List",
    element: <StudentAttendanceListView />,
  },
  { path: "Staff-Attendance-Dashboard", element: <StaffAttendanceDashboard /> },
  {
    path: "Staff-Attendance-Dashboard-List/:staffId",
    element: <StaffAttendanceListView />,
  },

  { path: "ReadMore", element: <ReadMoreAnnouncement /> },

  // Profile
  { path: "profile", element: <GroupCockpitProfile /> },
  { path: "change-password", element: <ChangePassword /> },
  { path: "content-management", element: <ContentManagement /> },
  { path: "AddHallOfFame", element: <HallofFameInfoCreate /> },
  { path: "ViewHallOfFame", element: <ViewHallOfFame /> },
  { path: "AddManagementTalk", element: <ManagementTalkInfoCreate /> },
  { path: "ViewManagementTalk", element: <ViewManagementTalk /> },
  { path: "AddNewsAndBlog", element: <NewsandBlogInfoCreate /> },
  { path: "ViewNewsAndBlogs", element: <ViewNewsAndBlogs /> },
  { path: "AddAnouncement", element: <AnnouncementInfoCreate /> },
  { path: "ViewAnnouncement", element: <ViewAnnouncement /> },
  { path: "ViewAllAnnouncement", element: <ViewAllAnnouncement /> },
  { path: "AddOpinionPoll", element: <OpinionInfoCreate /> },
  { path: "ViewOpinionPoll", element: <ViewOpinionPoll /> },

  //  AI Dashboard
  { path: "ai-dashboard", element: <AiDashboard /> },

  // Fees Discount
  { path: "listFeeDiscount", element: <ListFeeDiscount /> },
  { path: "createFeeDiscount", element: <CreateFeeDiscount /> },
  // Fees Type
  { path: "listFeeType", element: <ListFeeType /> },
  { path: "createFeeType", element: <CreateFeeType /> },
  // Fees Assign
  { path: "listAssignFees", element: <ListFeeAssign /> },
  { path: "createFeeAssign", element: <CreateFeeAssign /> },
  { path: "viewFeeAssign", element: <ViewFeeAssign /> },
  // Group Fee
  { path: "listGroupFee", element: <GroupFeeList /> },
  { path: "createGroupFee", element: <GroupFeeCreate /> },
  // Collect Fees
  { path: "listCollectFees", element: <ListCollectFees /> },
  { path: "payfees", element: <PayFees /> },

  // Payment Approval
  { path: "listPaymentApproval", element: <ListPaymentApproval /> },

  //Admin Collect Fees
  { path: "ListAdmissionCollectFees", element: <ListAdmissionCollectFees /> },
  { path: "viewCollectFees", element: <ViewCollectFees /> },

  //Admin  FeesDashboard
  { path: "feeDashboard", element: <FeeDashboard /> },

  //Admin Fee Report
  { path: "dueFeeReport", element: <DueFeeReport /> },
  { path: "discountReport", element: <DiscountReport /> },
  { path: "feesTransactionsReport", element: <FeesTransactionsReportTabs /> },

  //Admin Settings
  { path: "settings", element: <Settings /> },

  //Admin SchoolSetUp
  { path: "school-setup", element: <SchoolSetUp /> },
  { path: "school-setup/:id", element: <SchoolSetUp /> },
];

export default schoolCockpitRoutes;
